import api from '../../utils/axios';

const ratingByID = async (id) => {
	const { data } = await api.get(`/ratings/${id}`);

	return data;
};

const updateRatingByIDAddRating = async (id, rating) => {
	return await api.patch(`/ratings/${id}/add-rating`, rating);
};

const updateRatingByIDRemoveRating = async (id, rating) => {
	return await api.patch(`/ratings/${id}/remove-rating`, rating);
};

const ratingService = {
	ratingByID,
	updateRatingByIDAddRating,
	updateRatingByIDRemoveRating,
};

export default ratingService;
